import axios from "axios";
import { BaseUrl } from "../App";
import SellerServicesUrl from "../SellerServicesUrl";
import { mapProduct } from "../models/Product/ProductResponseModel";

export const fetchSellerHomeData = async (token) => {
  const res = await axios.get(
    BaseUrl + SellerServicesUrl.SellerHome,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  const data = res.data.data;

  return {
    banners: data.bannars || [],
    products: data.products?.map(mapProduct) || [],
  };
};